export enum TableHeaderVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
